const detectStorage = () => {
    const key = '___moveo___';
    try {
        localStorage.setItem(key, key);
        localStorage.removeItem(key);
        return 'localStorage';
    }
    catch (_) {
        try {
            sessionStorage.setItem(key, key);
            sessionStorage.removeItem(key);
            return 'sessionStorage';
        }
        catch (__) {
            return null;
        }
    }
};
export const storage = detectStorage();
const data = {};
/**
 * Sets a value in the browser's local/session storage.
 */
export const setItem = (key, value) => {
    if (storage) {
        return window[storage].setItem(key, value);
    }
    else {
        data[key] = value;
    }
};
/**
 * Gets a value in the browser's local/session storage.
 */
export const getItem = (key) => {
    if (storage) {
        return window[storage].getItem(key);
    }
    else {
        return data[key] || null;
    }
};
/**
 * Removes a value in the browser's local/session storage.
 */
export const removeItem = (key) => {
    if (storage) {
        return window[storage].removeItem(key);
    }
    else {
        delete data[key];
    }
};
